import React from 'react';
import { Typography, Row, Col } from 'antd';

import classnames from 'classnames';

const ProductTileFooter = (props) => {
  const { upc, sku } = props;
  const { Text } = Typography;

  return (
    <div className='product-tile__footer' justify='center' align='middle'>
      <Row style={{ width: '100%' }}>
        <Col xs={24} className='product-tile__footer-content'>
          <Text className='product-tile__footer-label' strong>
            UPC:
          </Text>
          <Text className='product-tile__footer-text' ellipsis={true}>
            {upc || 'N/A'}
          </Text>
        </Col>
        <Col xs={24} className='product-tile__footer-content'>
          <Text className='product-tile__footer-label' strong>
            SKU:
          </Text>
          <Text className='product-tile__footer-text' ellipsis={true}>
            {sku || 'N/A'}
          </Text>
        </Col>
      </Row>
    </div>
  );
};

export default ProductTileFooter;
